/* 🤖 this file was generated by svg-to-ts */
export const siriusBarcodePictogram: {
  name: 'barcode_pictogram';
  data: string;
} = {
  name: 'barcode_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path d="M34.5 8a1 1 0 1 0 0 2H41v6.5a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1h-7.5ZM7 31.5a1 1 0 1 0-2 0V39a1 1 0 0 0 1 1h7.5a1 1 0 1 0 0-2H7v-6.5ZM42 30.5a1 1 0 0 1 1 1V39a1 1 0 0 1-1 1h-7.5a1 1 0 1 1 0-2H41v-6.5a1 1 0 0 1 1-1ZM6 8a1 1 0 0 0-1 1v7.5a1 1 0 1 0 2 0V10h6.5a1 1 0 1 0 0-2H6ZM15 15.5a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0v-15a1 1 0 0 1 1-1ZM34 16.5a1 1 0 1 0-2 0v15a1 1 0 1 0 2 0v-15ZM27 15.5a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0v-15a1 1 0 0 1 1-1ZM22 16.5a1 1 0 1 0-2 0v15a1 1 0 1 0 2 0v-15Z" fill="currentColor"/></svg>`
};
